import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'

const MALDIVES_BANNER_END_DATE_MS = new Date('2026-02-17T00:00:00+11:00').getTime()

const MALDIVES_BANNER_BRANDS: Array<App.BrandName> = [
  'luxuryescapes',
  'leagenthub',
  'leagenthub_cvfr',
]

/**
 * Hook to determine if the Maldives Charter banner should be shown.
 * Shows for AU users until campaign end date.
 */
export function useShowMaldivesBanner(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isBrandSupported = MALDIVES_BANNER_BRANDS.includes(config.BRAND)
  const isRegionSupported = currentRegionCode === 'AU' || (config.agentHub.isEnabled && currentRegionCode === 'NZ')
  return isBrandSupported && isRegionSupported && Date.now() < MALDIVES_BANNER_END_DATE_MS
}
